/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import LocationAPI from '../api/location.js';

export const locations = {
    state: {
        pickupLocations: [],
        pickupLocationsLoadStatus: 0,

        locationAdded: {},
        locationAddStatus: 0,

        locationUpdated: {},
        locationUpdateStatus: 0,

        locationDeleted: {},
        locationDeleteStatus: 0,
        locationDeleteText: '',
    },

    actions: {
        loadPickupLocations({commit}) {
            return new Promise((resolve, reject) => {
                commit('setPickupLocationsLoadStatus', 1);

                LocationAPI.getPickupLocations()
                    .then(response => {
                        commit('setPickupLocations', response.data.data);
                        commit('setPickupLocationsLoadStatus', 2);
                        resolve();
                    })
                    .catch(() => {
                        commit('setPickupLocations', []);
                        commit('setPickupLocationsLoadStatus', 3);
                        reject();
                    });
            });
        },
    },

    mutations: {
        setPickupLocations( state, rawLocations ){
            state.pickupLocations = rawLocations.map(rawLocation => {
                return {
                    id: rawLocation.id,
                    name: rawLocation.name,
                    address: rawLocation.address,
                }
            });
        },
        setPickupLocationsLoadStatus( state, status ){
            state.pickupLocationsLoadStatus = status;
        },
    },

    getters: {
        getPickupLocations(state) {
            return state.pickupLocations;
        },
        getLocationsLoadStatus(state) {
            return state.pickupLocationsLoadStatus;
        },
    },
};

/**
 * Helpers
 */

